<script setup lang="ts">
import { AppStandardModal } from '@libs/ui';

interface PriceGuaranteeModalEmits {
  (eventName: 'close'): void;
}
const emit = defineEmits<PriceGuaranteeModalEmits>();
</script>

<template>
  <AppStandardModal
    :close-button-aria-label="$t('a11y.close_panel')"
    @close="emit('close')"
  >
    <template #title>{{ $t('price_guarantee.modal.title') }}</template>

    <template #body>
      <div class="price-guarantee-modal-body">
        <p>
          {{ $t('price_guarantee.modal.body.first_paragraph') }}
        </p>
        <ul>
          <li>
            {{ $t('price_guarantee.modal.body.list.first_item') }}
          </li>
          <li>
            {{ $t('price_guarantee.modal.body.list.second_item') }}
          </li>
          <li>
            {{ $t('price_guarantee.modal.body.list.third_item') }}
          </li>
        </ul>
        <p>
          {{ $t('price_guarantee.modal.body.second_paragraph') }}
        </p>
      </div>
    </template>
  </AppStandardModal>
</template>

<style scoped lang="scss">
.price-guarantee-modal-body {
  @include font-body-l-light;
  text-align: left;

  ul {
    list-style: none;
    padding-left: var(--spacing-8);

    li:before {
      content: '·';
      font-size: 20px;
      vertical-align: middle;
      line-height: 20px;
      margin-right: var(--spacing-8);
    }
  }
}
</style>
